import script from "./HackathonGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./HackathonGrid.vue?vue&type=script&setup=true&lang=js"

import "./HackathonGrid.vue?vue&type=style&index=0&id=211a9cb6&lang=css"

export default script